import React from 'react';
import styled from 'styled-components';
import { Theme, media } from '../theme';

const LegendContainer = styled.div`
  display: flex;
  flex-direction: row; // Changed to horizontal layout
  align-items: center;
  justify-content: center;
  gap: 24px; // Increased gap for horizontal spacing
  padding: 4px 16px; // Much slimmer padding
  background: transparent;
  border-radius: 0;
  font-size: 11px; // Slightly smaller font
  color: ${props => props.theme.text};
  
  ${media.mobile} {
    gap: 16px;
    padding: 4px 12px;
    font-size: 10px;
  }
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  
  ${media.mobile} {
    gap: 4px;
  }
`;

const TargetDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.theme.primary};
`;

const RangeBlock = styled.span`
  display: inline-block;
  width: 10px;
  height: 6px;
  background-color: ${props => props.theme.primary}80;
`;

const TimeLine = styled.span`
  display: inline-block;
  width: 12px;
  height: 1px;
  background-color: ${props => props.theme.primary};
  position: relative;
  top: -1px;
`;

const TopLine = styled.span`
  display: inline-block;
  width: 12px;
  height: 2px;
  background-color: ${props => props.theme.primary};
  position: relative;
  top: -1px;
`;

const BottomLine = styled.span`
  display: inline-block;
  width: 12px;
  height: 2px;
  background-color: ${props => props.theme.primary};
  position: relative;
  top: -1px;
`;

const SentimentIcon = styled.span`
  display: inline-block;
  font-size: 12px;
  color: #64B5F6;
`;

interface PriceLegendProps {
  theme: Theme;
}

export const PriceLegend: React.FC<PriceLegendProps> = ({ theme }) => {
  return (
    <LegendContainer>
      <LegendItem>
        <TargetDot /> Target Price
      </LegendItem>
      <LegendItem>
        <RangeBlock /> Price Range
      </LegendItem>
      <LegendItem>
        <TimeLine /> Price Time Range
      </LegendItem>
      <LegendItem>
        <TopLine /> TOP
      </LegendItem>
      <LegendItem>
        <BottomLine /> BOTTOM
      </LegendItem>
      <LegendItem>
        <SentimentIcon>💬</SentimentIcon> Sentiment
      </LegendItem>
    </LegendContainer>
  );
};
